module.exports = __webpack_public_path__ + "img/dashiji-2020.f16ea029.jpg";